import { useModal } from "@/features/modal/ModalStackManager";
import DefaultInstance, { BASE_URL } from "@/instance/axios";
import { useMutation } from "@tanstack/react-query";
import type { RawAxiosResponseHeaders } from "axios";
import axios from "axios";
import dayjs from "dayjs";
import saveAs from "file-saver";

const interportGetQuery = (file: File | undefined) =>
  DefaultInstance.interportImportPost(
    {
      file: file,
    },
    { responseType: "text" as const } // 업로드 결과를 문자열(JSON)로 받음
  );

export const useInterportMutationQuery = (file: File | undefined) => {
  const { closeModal } = useModal();
  return useMutation(() => interportGetQuery(file), {
    onSuccess: (res) => {
      // 업로드 결과(생성완료/실패 등)를 txt 파일로 다운로드
      const raw = typeof res.data === "string" ? res.data : JSON.stringify(res.data);
      let parsed: { statusCode?: number } = {};
      try {
        parsed = JSON.parse(raw);
      } catch {
        parsed = {};
      }

      const prettyJson = JSON.stringify(parsed, null, 2);
      const blob = new Blob([prettyJson], { type: "text/plain;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${dayjs().format("YYYYMMDD")}_업로드결과.txt`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      if (parsed.statusCode === 400) {
        alert("업로드에 실패한 항목이 있습니다. 결과 파일을 확인해주세요.");
      } else {
        alert("성공적으로 업로드 되었습니다.");
      }
      closeModal({});
    },
    onError: () => {
      alert("업로드에 실패했습니다.");
    },
  });
};

export const useInterportDownloadQuery = {
  download: (setLoading: (loading: boolean) => void) => {
    setLoading(true);
    return axios
      .post<Blob>(
        `${BASE_URL}/interport/export`,
        {},
        {
          responseType: "blob",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("authToken"),
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/octet-stream",
          },
        }
      )
      .then((response) => {
        setLoading(false);
        const finalName = `${dayjs().format("YYYYMMDD")}_기준정보.xlsx`;

        const headers = response.headers as RawAxiosResponseHeaders;
        const rawType = headers["content-type"];
        const type =
          typeof rawType === "string"
            ? rawType
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blob =
          response.data instanceof Blob ? response.data : new Blob([response.data], { type });

        saveAs(blob, finalName);
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
      });
  },
};
